// import { useState } from "react";
// import "./home.css";
// import "react-lazy-load-image-component/src/effects/blur.css";
// import { useSelector } from "react-redux";
// import IAM from "../IAM/IAM";   //org inspect

// import Dashboard from "../super_admin/dashboard/Dashboard";  //dashboard superadmin
// import Onboard from "../super_admin/onboard/Onboard";
// import InspectSuper from "../super_admin/dashboard/InspectSuper";
// // import  ProgramDashboard from "../program_admin/ProgramOnboard"

// function Home() {
//   const userType = useSelector((state) => state.appStore?.user?.userType);
//   // const [activeComponent, setActiveComponent] = useState(userType === "super_admin" ? "dashboard" : "org_dashboard");
//   const [activeComponent, setActiveComponent] = useState(
//     userType === "super_admin" ? "dashboard" : "inspect"
//   );

//   console.log("20-usertype", userType);

//   const handleNavigation = (component) => {
//     setActiveComponent(component);
//   };

//   const dashboard = `${process.env.PUBLIC_URL}/home-sidebar/dashboard.png`;
//   const organisation_super = `${process.env.PUBLIC_URL}/home-sidebar/org-super.svg`;
//   const inspect_super = `${process.env.PUBLIC_URL}/home-sidebar/inspect-super.svg`;
//   const organisation_org = `${process.env.PUBLIC_URL}/home-sidebar/org-org.svg`;
//   const inspect_org = `${process.env.PUBLIC_URL}/home-sidebar/inspect-org.svg`;
//   const user = `${process.env.PUBLIC_URL}/home-sidebar/user-grey.png`;

//   const menuItems = [
//     {
//       key: userType === "org_admin"
//         ? "org_dashboard"
//         : userType === "super_admin"
//           ? "dashboard"
//           : "",
//       label: "Dashboard",
//       icon: dashboard,
//       visible: userType === "super_admin", // ✅ org_admin dashboard hidden
//     },
//     {
//       key: userType === "org_admin"
//         ? "onboard_org"
//         : userType === "super_admin"
//           ? "onboard_super"
//           : "",
//       label: userType === "org_admin"
//         ? "Organisation"
//         : userType === "super_admin"
//           ? "Add Organisation"
//           : "",
//       icon: userType === "org_admin"
//         ? organisation_org
//         : userType === "super_admin"
//           ? organisation_super
//           : '',
//       visible: userType === "super_admin", // ✅ org_admin organisation hidden
//     },
//     {
//       key: userType === "org_admin" ? "inspect" : "inspectSuper",
//       label: "Inspect",
//       icon: userType === "org_admin" ? inspect_org : inspect_super,
//       visible: true, // ✅ Always visible
//     },
//   ];

//   return (
//     <div style={{ height: "100svh", display: "flex", flexDirection: "column" }}>
//       <div className="app-container" style={{ display: "flex", flex: 1 }}>
//         {/* Sidebar */}
//         <div
//           className="sidebar-home"
//           style={{
//             width: "298px",
//             boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <ul className="sidebar-menu">
//             {menuItems
//               .filter((item) => item.visible)
//               .map((item) => (
//                 <li
//                   key={item.key}
//                   onClick={() => handleNavigation(item.key)}
//                   className={activeComponent === item.key ? "active" : ""}
//                 >
//                   <a>
//                     <img
//                       src={item.icon}
//                       alt={`${item.label} Icon`}
//                       className="sidebar-icon"
//                     />
//                     {item.label}
//                   </a>
//                 </li>
//               ))}
//           </ul>
//         </div>

//         {/* Main Content */}
//         <div
//           style={{
//             height: "86svh",
//             overflowY: "auto",
//             width: "100%",
//           }}
//         >
//           {activeComponent === "dashboard" && <Dashboard />}
//           {activeComponent === "onboard_super" && <Onboard />}
//           {activeComponent === "inspectSuper" && <InspectSuper />}

//           {activeComponent === "inspect" && <IAM />}

//         </div>
//       </div>
//     </div>
//   );
// }

// export default Home;

//2
// import React, { useState } from 'react'
// import './home.css'
// import 'react-lazy-load-image-component/src/effects/blur.css'
// import { useSelector } from 'react-redux'
// import Users from '../org_admin/Users/Users'
// import IAM from '../IAM/IAM'
// import OrgDashboard from '../dashboard/OrgDashboard'
// import Organisation from '../org_admin/Organisation'
// import Onboard from '../super_admin/onboard/Onboard'
// import Dashboard from "../super_admin/dashboard/Dashboard";  //dashboard superadmin
// import InspectSuper from "../super_admin/dashboard/InspectSuper";
// import InspectProgram from "../program_admin/dashboard/InspectProgram"
// import ProgramDashboard from '../program_admin/ProgramDashboard'
// function Home () {
//   const userType = useSelector(state => state.appStore?.user?.userType)
//   const [activeComponent, setActiveComponent] = useState(
//     userType === 'super_admin' ? 'dashboard' : 'org_dashboard'
//   )
//   console.log(userType)

//   const handleNavigation = component => {
//     setActiveComponent(component)
//   }

//   const dashboard = `${process.env.PUBLIC_URL}/home-sidebar/dashboard.png`
//   const organisation_super = `${process.env.PUBLIC_URL}/home-sidebar/org-super.svg`
//   const inspect_super = `${process.env.PUBLIC_URL}/home-sidebar/inspect-super.svg`
//   const organisation_org = `${process.env.PUBLIC_URL}/home-sidebar/org-org.svg`
//   const inspect_org = `${process.env.PUBLIC_URL}/home-sidebar/inspect-org.svg`
//   const user = `${process.env.PUBLIC_URL}/home-sidebar/user-grey.png`

// const menuItems = [
//   {
//     key:
//       userType === 'org_admin'
//         ? 'org_dashboard'
//         : userType === 'super_admin'
//         ? 'dashboard'
//         : '',
//     label: 'Dashboard',
//     icon: dashboard,
//     visible: true
//   },
//   {
//     key:
//       userType === 'org_admin'
//         ? 'onboard_org'
//         : userType === 'super_admin'
//         ? 'onboard_super'
//         : '',
//     label:
//       userType === 'org_admin'
//         ? 'Organisation'
//         : userType === 'super_admin'
//         ? 'Add Organisation'
//         : '',
//     icon:
//       userType === 'org_admin'
//         ? organisation_org
//         : userType === 'super_admin'
//         ? organisation_super
//         : '',
//     visible: userType === 'super_admin'
//   },
//   {
//     key: userType === 'org_admin' ? 'inspect' : 'inspectSuper',
//     label: 'Inspect',
//     icon: userType === 'org_admin' ? inspect_org : inspect_super,
//     visible: true
//   },
//   {
//     key: 'add_program',
//     label: 'Add Program',
//     icon: `${process.env.PUBLIC_URL}/home-sidebar/add-program.svg`,
//     visible: userType === 'org_admin'
//   }
// ]

//   return (
//     <div style={{ height: '100svh', display: 'flex', flexDirection: 'column' }}>
//       <div className='app-container' style={{ display: 'flex', flex: 1 }}>
//         {/* Sidebar */}
//         <div
//           className='sidebar-home'
//           style={{
//             width: '298px',
//             boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
//           }}
//         >
//           <ul className='sidebar-menu'>
//             {menuItems
//               .filter(item => item.visible)
//               .map(item => (
//                 <li
//                   key={item.key}
//                   onClick={() => handleNavigation(item.key)}
//                   className={activeComponent === item.key ? 'active' : ''}
//                 >
//                   <a>
//                     <img
//                       src={item.icon}
//                       alt={`${item.label} Icon`}
//                       className='sidebar-icon'
//                     />
//                     {item.label}
//                   </a>
//                 </li>
//               ))}
//           </ul>
//         </div>

//         {/* Main Content */}
//         <div
//           style={{
//             height: '86svh',
//             overflowY: 'auto',
//             width: '100%'
//           }}
//         >
//           {activeComponent === 'dashboard' && <Dashboard />}
//           {activeComponent === 'org_dashboard' && <OrgDashboard />}
//           {activeComponent === 'onboard_super' && <Onboard />}
//           {activeComponent === 'onboard_org' && <Organisation />}
//           {activeComponent === 'inspect' && <IAM />}
//           {activeComponent === 'inspectSuper' && <InspectSuper />}
//           {activeComponent === 'users' && <Users />}
//           {activeComponent === 'add_program' && <ProgramDashboard />}

//         </div>
//       </div>
//     </div>
//   )
// }

// export default Home

//3
import React, { useState } from 'react'
import './home.css'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { useSelector } from 'react-redux'
import Users from '../org_admin/Users/Users'
import IAM from '../IAM/IAM'
import OrgDashboard from '../dashboard/OrgDashboard'
import Organisation from '../org_admin/Organisation'
import Onboard from '../super_admin/onboard/Onboard'
import Dashboard from '../super_admin/dashboard/Dashboard'
import InspectSuper from '../super_admin/dashboard/InspectSuper'
import InspectProgram from '../program_admin/dashboard/InspectProgram'
import ProgramDashboard from '../program_admin/ProgramDashboard'

function Home() {
  const userType = useSelector(state => state.appStore?.user?.userType)
  const [activeComponent, setActiveComponent] = useState(
    userType === 'super_admin'
      ? 'dashboard'
      : userType === 'org_admin'
      ? 'inspect'
      : userType === 'program_admin'
      ? 'inspectProgram'
      : ''
  )

  const handleNavigation = component => setActiveComponent(component)

  // sidebar icons
  const dashboard = `${process.env.PUBLIC_URL}/home-sidebar/dashboard.png`
  const organisation_super = `${process.env.PUBLIC_URL}/home-sidebar/org-super.svg`
  const inspect_super = `${process.env.PUBLIC_URL}/home-sidebar/inspect-super.svg`
  const organisation_org = `${process.env.PUBLIC_URL}/home-sidebar/org-org.svg`
  const inspect_org = `${process.env.PUBLIC_URL}/home-sidebar/inspect-org.svg`
  const inspect_program = `${process.env.PUBLIC_URL}/home-sidebar/inspect-org.svg`
  const user = `${process.env.PUBLIC_URL}/home-sidebar/user-grey.png`

  const menuItems = [
    // SUPER ADMIN
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: dashboard,
      visible: userType === 'super_admin'
    },
    {
      key: 'onboard_super',
      label: 'Add Organisation',
      icon: organisation_super,
      visible: userType === 'super_admin'
    },
    {
      key: 'inspectSuper',
      label: 'Inspect',
      icon: inspect_super,
      visible: userType === 'super_admin'
    },

    // ORG ADMIN
    // {
    //   key: 'org_dashboard',
    //   label: 'Dashboard',
    //   icon: dashboard,
    //   visible: userType === 'org_admin'
    // },
    // {
    //   key: 'onboard_org',
    //   label: 'Organisation',
    //   icon: organisation_org,
    //   visible: userType === 'org_admin'
    // },
    {
      key: 'inspect',
      label: 'Inspect',
      icon: inspect_org,
      visible: userType === 'org_admin'
    },
    {
      key: 'add_program',
      label: 'Add Program',
      icon: `${process.env.PUBLIC_URL}/org_admin/org_logo.png`,
      visible: userType === 'org_admin'
    },

    // PROGRAM ADMIN
    {
      key: 'inspectProgram',
      label: 'Inspect',
      icon: inspect_program,
      visible: userType === 'program_admin'
    },
    // {
    //   key: 'users',
    //   label: 'Users',
    //   icon: user,
    //   visible: userType === 'program_admin'
    // }
  ]

  return (
    <div style={{ height: '100svh', display: 'flex', flexDirection: 'column' }}>
      <div className='app-container' style={{ display: 'flex', flex: 1 }}>
        {/* Sidebar */}
        <div
          className='sidebar-home'
          style={{
            width: '298px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
          }}
        >
          <ul className='sidebar-menu'>
            {menuItems
              .filter(item => item.visible)
              .map(item => (
                <li
                  key={item.key}
                  onClick={() => handleNavigation(item.key)}
                  className={activeComponent === item.key ? 'active' : ''}
                >
                  <a>
                    <img
                      src={item.icon}
                      alt={`${item.label} Icon`}
                      className='sidebar-icon'
                    />
                    {item.label}
                  </a>
                </li>
              ))}
          </ul>
        </div>

        {/* Main Content */}
        <div
          style={{
            height: '86svh',
            overflowY: 'auto',
            width: '100%'
          }}
        >
          {activeComponent === 'dashboard' && <Dashboard />}
          {activeComponent === 'org_dashboard' && <OrgDashboard />}
          {activeComponent === 'onboard_super' && <Onboard />}
          {activeComponent === 'onboard_org' && <Organisation />}
          {activeComponent === 'inspect' && <IAM />}
          {activeComponent === 'inspectSuper' && <InspectSuper />}
          {activeComponent === 'users' && <Users />}
          {activeComponent === 'add_program' && <ProgramDashboard />}
          {activeComponent === 'inspectProgram' && <InspectProgram />}
        </div>
      </div>
    </div>
  )
}


export default Home

